import { useNavigate, useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';

import { resetOnboarding } from './hint-store.js';

/**
 * Watches the raw query string for `?resetOnboarding=1`, clears the onboarding
 * seen-state, then strips that param with a replace navigation so a reload does
 * not reset again. Other query params are kept.
 */
export function ResetOnboardingEffect(): null {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.searchStr);
    if (searchParams.get('resetOnboarding') !== '1') return;

    resetOnboarding();
    searchParams.delete('resetOnboarding');

    const nextSearch: Record<string, string> = {};
    for (const [key, value] of searchParams.entries()) {
      nextSearch[key] = value;
    }

    void navigate({
      to: location.pathname,
      search: nextSearch as never,
      replace: true,
    });
  }, [location.searchStr, location.pathname, navigate]);

  return null;
}
